// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"931439ea","504":"5314e45a","647":"35b2e703","729":"aa195ae3","778":"fc8f8a08","936":"48a08b37"}[chunkId] + ".chunk.js";
};